<template>

    <select-input
    :label="label"
    v-model="ratesData"
    value-key="id"
    label-value="name"
    :placeholder="placeholder"
    :size="size"
    :required="required"
    :disabled="disabled" @change="updated" />


</template>

<script>

import PostMixins from '@/mixins/PostMixins'

export default {
  name: 'select-sharer-rates',

  mixins: [PostMixins],

  props: {

    label: {
      type: String,
      default: 'Sharer Rates'
    },

    sharerId: {
      type: Number,
      required: true,
    },

    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'default'
    },

    placeholder: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    noForm: {
      type: Boolean,
      default: false
    }
  },

methods: {
  success (data) {
   this.ratesData = data
    console.log(this.ratesData)
  },

  updated (value) {
    this.ratesData = value
    this.$emit('value', value)
    this.$emit('change', value)
  }
},

data () {
  return {
    ratesData: []
  }
},

mounted () {
  this.fetchData('rates/sharer', this.success, 'Sharer Rates')
  }
}

</script>

<style scoped>
.el-cascader {display: inline-block; width: 100%;}
</style>



// WEBPACK FOOTER //
// SelectSharerRates.vue?485326b8